export default __webpack_public_path__ + "images/d794a28cd39085bd63da0cfd94d87018.jpg";